import { render, staticRenderFns } from "./sectionItemSecond.vue?vue&type=template&id=f96a59f2&scoped=true"
import script from "./sectionItemSecond.vue?vue&type=script&lang=ts"
export * from "./sectionItemSecond.vue?vue&type=script&lang=ts"
import style0 from "./sectionItemSecond.vue?vue&type=style&index=0&id=f96a59f2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f96a59f2",
  null
  
)

export default component.exports